// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"d8ba549c","117":"029b1621","150":"d8ba549c"}[chunkId] + ".chunk.css";
};